// Wrap your app's router with this to catch React render errors
// and send them to Sentry with a user-friendly fallback UI

import * as Sentry from '@sentry/react';

export default function SentryErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--brand-paper)', fontFamily: 'var(--font-body)', padding: 'var(--space-xxl)',
        }}>
          <div style={{ maxWidth: 420, textAlign: 'center' }}>
            <div style={{ fontSize: 'var(--font-size-h1)', marginBottom: 'var(--space-lg)' }}>📚</div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 22, color: 'var(--neutral-800)', margin: '0 0 8px' }}>
              Something went wrong
            </h2>
            <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-500)', margin: '0 0 20px', lineHeight: 1.6 }}>
              We've been notified and will look into it. Try refreshing the page.
            </p>
            <div style={{ display: 'flex', gap: 'var(--space-10)', justifyContent: 'center' }}>
              <button
                onClick={() => window.location.reload()}
                style={{ padding: '10px 20px', background: 'var(--brand-rust)', color: 'var(--brand-white)', border: 'none', borderRadius: 'var(--radius-lg)', fontSize: 'var(--font-size-base)', fontWeight: 700, cursor: 'pointer' }}>
                Refresh page
              </button>
              <button
                onClick={resetError}
                style={{ padding: '10px 20px', background: 'var(--brand-white)', color: 'var(--neutral-800)', border: '1px solid var(--brand-sand)', borderRadius: 'var(--radius-lg)', fontSize: 'var(--font-size-base)', fontWeight: 600, cursor: 'pointer' }}>
                Try again
              </button>
            </div>
          </div>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}